import {Injectable} from "@angular/core";
import {LoginServerService} from "src/app/layouts/public/login/services/login-server.service";
import {FeatureFlagService} from "./featureFlag.service";
import {Router} from "@angular/router";
import {StyleService} from "../components/style/style.service";
import {RaygunService} from "./raygun.service";
import {TokenResult} from "../../layouts/public/login/models/tokenresult";

@Injectable({
    providedIn: 'root'
})
export class AppInitService {


    constructor(private _styleService: StyleService, private _loginService: LoginServerService, private _featureFlagService: FeatureFlagService, private router: Router, private _raygunService: RaygunService) {
    }
    public redirectUrl: string;
    public cloudToken: string;
    public rememberMe: boolean;
    public siteId: string = null;
    public accountId: string = null;

    Init() {

        return new Promise<void>(async (resolve, reject) => {
            const params = new URLSearchParams(window.location.search);

            await this._raygunService.loadRaygunSettings();

            let isSSO = params.has("connectfrommicroitoken") || params.has("udata");
            
            let getStyles = false;
            
            await this._loginService.preSetup();
            
            if (params.has("connectfrommicroitoken")) {
                if (params.has("redirectUrl")) {
                    this.redirectUrl = params.get("redirectUrl");
                }

                if (params.has("rememberMe")) {
                    console.log("in rememberMe");
                    this.rememberMe = params.get("rememberMe").toLowerCase() == 'true';
                }

                if (params.has("siteId") && params.get("siteId").toLowerCase() != "null" && params.get("siteId") != "") {
                    console.log("in siteId");
                    this.siteId = params.get("siteId");
                } else if (params.has("accountId") && params.get("accountId").toLowerCase() != "null" && params.get("accountId") != "") {
                    console.log("in accountId");
                    this.accountId = params.get("accountId");
                }

                this.cloudToken = params.get("connectfrommicroitoken");
                
                const loginResult = await this._loginService.connectFromDevice(this.cloudToken, this.rememberMe, this.redirectUrl, this.siteId, this.accountId);

                if (!loginResult.success) {
                    await this.router.navigate([this.redirectUrl]);
                }
                else {
                    await this.router.navigate([loginResult.returnUrl]);
                }
            } else if (params.has("udata")) {
                console.log("Access token found in URL");
                let tokenResponseEncoded = params.get("udata");

                const urlDecoded = decodeURIComponent(tokenResponseEncoded);
                const jsonString = atob(urlDecoded);
                const tokenContent: TokenResult = JSON.parse(jsonString);

                // Extract returnUrl from query parameters if present
                let returnUrl = params.has("returnUrl") ? params.get("returnUrl") : "/";

                await this._loginService.loginWithToken(tokenContent);
                getStyles = true;
                
                await this.router.navigate([returnUrl])
            } else {
                getStyles = true;
            }
            
            await this._loginService.setup(isSSO);

            await this._featureFlagService.initialize();

            if (getStyles)
                await this._styleService.getUsersStyles();
            
            resolve();
        });
    }
}